import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/users-actions",
		component: lazy(() => import("./UserActionsPage")),
	},
]);
